import { Sidebar } from "@components/layout/Sidebar";
import { SidebarNavLink } from "@components/layout/SidebarNavLink";
import { NotFoundPage } from "@components/NotFoundPage";
import { settingsPages } from "@lib/settings";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
  notFoundComponent: () => <NotFoundPage />,
});

function SettingsLayout() {
  return (
    <div className="flex flex-1 overflow-hidden">
      <Sidebar className="w-72 shrink-0">
        <div className="flex h-8 items-center">
          <span className="font-medium text-gray-600 text-sm">Settings</span>
        </div>
        <nav className="mt-4 space-y-1">
          {settingsPages.map((page) => (
            <SidebarNavLink key={page.path} to={page.path}>
              <page.icon className="size-4" />
              {page.label}
            </SidebarNavLink>
          ))}
        </nav>
      </Sidebar>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
